import { Route } from 'react-router-dom'

// Layout
import BusinessOwnerLayout from '../layout/BusinessOwnerLayout'

// Pages
import BusinessDashboardPage from '../pages/business/BusinessDashboardPage'
import BusinessManagementPage from '../pages/business/BusinessManagementPage'
import MenuManagementPage from '../pages/business/MenuManagementPage'
import SettingsPage from '../pages/business/SettingsPage'
import CampaignManagementPage from '../pages/business/CampaignManagementPage'
import CreateEditCampaignPage from '../pages/business/CreateEditCampaignPage'

// Guards
import ProtectedRoute from '../core/guards/ProtectedRoute'
import { AppRoute } from '../core/config/app-routes'
import BusinessDetailsPage from '../pages/business/BusinessDetailsPage'
import BusinessEditPage from '../pages/business/BusinessEditPage'
import BusinessCreatePage from '../pages/business/BusinessCreatePage'
import UserManagementPage from '../pages/business/UserManagementPage'

export default function BusinessOwnerRoutes() {
  return (
    <>
      <Route
        path={AppRoute.BUSINESS_OWNER_DASHBOARD_ROUTE}
        element={
          <ProtectedRoute>
            <BusinessOwnerLayout>
              <BusinessDashboardPage />
            </BusinessOwnerLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path={AppRoute.BUSINESS_OWNER_BUSINESSES_ROUTE}
        element={
          <ProtectedRoute>
            <BusinessOwnerLayout>
              <BusinessManagementPage />
            </BusinessOwnerLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path={AppRoute.BUSINESS_OWNER_BUSINESSES_ROUTE + '/create'}
        element={
          <ProtectedRoute>
            <BusinessOwnerLayout>
              <BusinessCreatePage />
            </BusinessOwnerLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path={AppRoute.BUSINESS_OWNER_BUSINESSES_ROUTE + '/:businessId/edit'}
        element={
          <ProtectedRoute>
            <BusinessOwnerLayout>
              <BusinessEditPage />
            </BusinessOwnerLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path={AppRoute.BUSINESS_OWNER_BUSINESSES_ROUTE + '/:businessId'}
        element={
          <ProtectedRoute>
            <BusinessOwnerLayout>
              <BusinessDetailsPage />
            </BusinessOwnerLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path={AppRoute.BUSINESS_OWNER_MENU_ROUTE}
        element={
          <ProtectedRoute>
            <BusinessOwnerLayout>
              <MenuManagementPage />
            </BusinessOwnerLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path={AppRoute.BUSINESS_OWNER_MENU_ROUTE}
        element={
          <ProtectedRoute>
            <BusinessOwnerLayout>
              <MenuManagementPage />
            </BusinessOwnerLayout>
          </ProtectedRoute>
        }
      />

      {/* Campaign Management */}
      <Route
        path={AppRoute.BUSINESS_OWNER_CAMPAIGNS_ROUTE}
        element={
          <ProtectedRoute>
            <BusinessOwnerLayout>
              <CampaignManagementPage />
            </BusinessOwnerLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path={AppRoute.BUSINESS_OWNER_CAMPAIGNS_ROUTE + '/create'}
        element={
          <ProtectedRoute>
            <BusinessOwnerLayout>
              <CreateEditCampaignPage />
            </BusinessOwnerLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path={AppRoute.BUSINESS_OWNER_CAMPAIGNS_ROUTE + '/:id/edit'}
        element={
          <ProtectedRoute>
            <BusinessOwnerLayout>
              <CreateEditCampaignPage />
            </BusinessOwnerLayout>
          </ProtectedRoute>
        }
      />

      {/* User Management */}
      <Route
        path={AppRoute.BUSINESS_OWNER_USERS_ROUTE}
        element={
          <ProtectedRoute>
            <BusinessOwnerLayout>
              <UserManagementPage />
            </BusinessOwnerLayout>
          </ProtectedRoute>
        }
      />

      {/* Settings */}
      <Route
        path={AppRoute.BUSINESS_OWNER_SETTINGS_ROUTE}
        element={
          <ProtectedRoute>
            <BusinessOwnerLayout>
              <SettingsPage />
            </BusinessOwnerLayout>
          </ProtectedRoute>
        }
      />
    </>
  )
}


